
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternOnColourOff as ObiLightLanternOnColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-on-colour-off.js';
 
 
 

 
 export const ObiLightLanternOnColourOff = createComponent({
   react: React,
   tagName: 'obi-light-lantern-on-colour-off',
   elementClass: ObiLightLanternOnColourOffElement,
   events: {
     
   }
  });
 
 